import React from 'react';

const PaintVenueGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <g transform="translate(26 39)">
                <path
                    fill="#FFF"
                    d="M17.931 13.558v48.498h65.854c4.078-2.1 6.117-5.487 6.117-10.162v-39.74c-.54-6.657-3.776-9.985-9.708-9.985-5.93 0-9.308 3.796-10.13 11.389H17.93z"
                />
                <path
                    fill="#D3D7DF"
                    fillRule="nonzero"
                    d="M69.792 52.704l12.96 10.944s6.912-6.24 6.912-12.96c0-6.912-5.76-8.256-9.984-8.544-4.032-.384-11.232 3.648-9.888 10.56z"
                />
                <path
                    fill="#D3D7DF"
                    fillRule="nonzero"
                    d="M85.728 6.048h2.784V45.12h-2.784z"
                />
                <g fill="#363A43" fillRule="nonzero">
                    <path d="M80.064 64.224H16.512V11.712h52.512v2.784H19.2V61.44h60.768c4.512 0 8.256-3.744 8.256-8.256 0-4.512-3.744-8.256-8.256-8.256-4.512 0-8.256 3.744-8.256 8.256h-2.784c0-6.048 4.992-11.04 11.04-11.04 6.048 0 11.04 4.992 11.04 11.04 0 6.048-4.896 11.04-10.944 11.04z" />
                    <path d="M91.104 53.088H88.32V11.712c0-4.512-3.744-8.256-8.256-8.256-4.512 0-8.256 3.744-8.256 8.256v41.472h-2.784V11.712c0-6.048 4.992-11.04 11.04-11.04 6.048 0 11.04 4.992 11.04 11.04v41.376z" />
                </g>
                <circle
                    cx={57.216}
                    cy={25.92}
                    r={4.8}
                    fill="#F16932"
                    fillRule="nonzero"
                />
                <circle
                    cx={44.064}
                    cy={25.92}
                    r={4.8}
                    fill="#F16932"
                    fillRule="nonzero"
                />
                <circle
                    cx={31.008}
                    cy={25.92}
                    r={4.8}
                    fill="#F16932"
                    fillRule="nonzero"
                />
                <circle
                    cx={57.216}
                    cy={37.92}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <circle
                    cx={44.064}
                    cy={37.92}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <circle
                    cx={31.008}
                    cy={37.92}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <circle
                    cx={57.216}
                    cy={50.112}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <circle
                    cx={44.064}
                    cy={50.112}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <circle
                    cx={31.008}
                    cy={50.112}
                    r={4.8}
                    fill="#8C9293"
                    fillRule="nonzero"
                />
                <path
                    fill="#363A43"
                    fillRule="nonzero"
                    d="M5.952 50.784a5.572 5.572 0 0 1-5.568-5.568V17.472a5.572 5.572 0 0 1 5.568-5.568 5.572 5.572 0 0 1 5.568 5.568v27.936c0 3.072-2.496 5.376-5.568 5.376z"
                />
                <path
                    fill="#FFF"
                    d="M5.952 14.688a2.786 2.786 0 0 0-2.784 2.784v27.936a2.786 2.786 0 0 0 2.784 2.784 2.786 2.786 0 0 0 2.784-2.784V17.472a2.786 2.786 0 0 0-2.784-2.784z"
                />
                <g fillRule="nonzero">
                    <path
                        fill="#F16932"
                        d="M5.664 53.376c1.92-.096 3.84 1.248 3.84 4.128 0 2.112-3.072 2.304-3.168 6.048 0 0-4.512-1.344-4.512-5.568 0-3.744 2.592-4.416 3.84-4.608z"
                    />
                    <path
                        fill="#363A43"
                        d="M7.68 65.568l-1.632-.576C5.76 64.896.48 63.168.48 58.08c0-4.512 3.168-5.952 5.088-6.048 1.344-.096 2.592.384 3.552 1.248.864.672 1.632 2.112 1.632 4.32 0 1.344-.864 2.304-1.632 3.072-.864.864-1.536 1.536-1.536 3.072v1.824h.096zM5.664 54.816c-.864 0-2.592.384-2.592 3.36 0 1.824 1.152 2.88 2.208 3.552.576-1.344 1.344-2.304 2.112-2.88.576-.576.864-.864.864-1.152 0-.96-.288-1.824-.864-2.208-.48-.576-1.152-.672-1.728-.672z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

PaintVenueGraphicSvg.displayName = 'PaintVenueGraphicSvg';
export default PaintVenueGraphicSvg;
